<template>
  <router-view />
</template>

<script setup>
</script>

<style>
html, body {
  margin: 0;
  padding: 0;
  background-color: #f5f7fa;
}

.app {
  min-height: 100vh;
}
</style>